import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import {
  IntegranteSolicitudRequest,
  IntegranteSolicitudResponse,
} from '../../models/integrante-solicitud/integrante-solicitud';

@Injectable({
  providedIn: 'root',
})
export class IntegranteSolicitudService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.INTEGRANTES_SOLICITUD}`;
  private apiUrlLote = `${ENV.HOST}${URL_MAP.API.INTEGRANTES_SOLICITUD_LOTE}`;

  constructor(private http: HttpClient) {}

  guardarIntegrante(
    request: IntegranteSolicitudRequest,
  ): Observable<IntegranteSolicitudResponse> {
    return this.http.post<IntegranteSolicitudResponse>(this.apiUrl, request);
  }

  guardarLote(
    request: IntegranteSolicitudRequest[],
  ): Observable<IntegranteSolicitudResponse[]> {
    return this.http.post<IntegranteSolicitudResponse[]>(
      this.apiUrlLote,
      request,
    );
  }
}
